import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Paper,
  Radio,
  Select,
  Stack,
  Switch,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useRef, useMemo } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import StorageIcon from "@mui/icons-material/Storage";
import { styled } from "@mui/material/styles";
import {
  useFetchPrincipalEntitiesdataQuery,
  useGetSearchFilesQuery,
} from "../../../../store/services/principleApi";
import { useFetchHeadersByPrincipalIdQuery } from "../../../../store/services/headerApi ";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { formatedCurrentDateTime } from "../../../../utility/GetCurrentDateTime";
import {
  useLazyCheckSpamKeywordsQuery,
  usePreviewDataMutation,
  useUploadSplitSMSMutation,
} from "../../../../store/services/smsApi";
import { useGetTemplateByPrincipalIdQuery } from "../../../../store/services/templateApi";
import { useGetCustomerCountriesQuery } from "../../../../store/services/blacklistApi";
import Loader from "../../../common/Loader";
import { maskNumber } from "../../../common/Encryption";
import * as XLSX from "xlsx";
import {
  useCheckMpinStatusQuery,
  useVerifyMpinStatusMutation,
} from "../../../../store/services/userApi";
import { Table } from "react-bootstrap";
import { useDataEnableServiceQuery } from "../../../../store/services/flowApi";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const FIELD_HEIGHT = 35;
const FORM_MAX_WIDTH = 510;

// Shows first 3 + "..." + last 3 characters
const trimPeId = (id) => {
  const str = String(id ?? "");
  if (str.length <= 6) return str;
  return `${str.slice(0, 3)}...${str.slice(-3)}`;
};

// Tighter dropdown options (matches BulkSMS)
const compactMenuProps = {
  PaperProps: {
    sx: {
      "& .MuiMenuItem-root": {
        minHeight: 28,
        py: 0.25,
        px: 1.5,
        fontSize: "0.8rem",
      },
    },
  },
  MenuListProps: { dense: true, sx: { py: 0.5 } },
};

// ─── Shared glass token (mirrors BulkSMS) ────────────────────────────────────
const glassField = {
  height: FIELD_HEIGHT,
  fontSize: "0.8rem",
  background: "rgba(255,255,255,0.7)",
  backdropFilter: "blur(8px)",
  borderRadius: "8px",
  "&:hover": { boxShadow: "0 4px 12px rgba(0,0,0,0.05)" },
};

const Split = ({ service_id, onPreviewChange }) => {
  const [smsType, setSmsType] = useState(() => localStorage.getItem("smsType") || "english");
  const [isSubmit, setIsSubmit] = useState(false);
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const [reviewData, setReviewData] = useState(null);
  const [smstext, setSmsText] = useState("");
  const [charCountState, setCharCountState] = useState(0);
  const [smsCountState, setSmsCountState] = useState(0);
  const [templateId, setTemplateId] = useState("");
  const [peId, setPeId] = useState("");
  const [selectedTemplateName, setSelectedTemplateName] = useState("");
  const [isAllow, setIsAllow] = useState(false);
  const [countdownTimer, setCountdownTimer] = useState(null);
  const [fileNames, setFileNames] = useState("");
  const [file, setFile] = useState(null);
  const [phoneNumbers, setPhoneNumbers] = useState("");
  const [entityId, setEntityId] = useState(null);
  const [prId, setPrId] = useState(null);
  const [error, setError] = useState("");
  const [currentLanguage, setCurrentLanguage] = useState("hi");
  const [enableFilterTill, setEnableFilterTill] = React.useState(false);
  const [filterDatatill_days, setFilterDatatill_days] = useState(0);
  const [isPrincipalEntitySelected, setIsPrincipalEntitySelected] = useState(false);
  const [headers, setHeaders] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [principalEntities, setPrincipalEntities] = useState([]);
  const [headerName, setHeaderName] = useState("");
  const [isTransliterationEnabled, setIsTransliterationEnabled] = useState(false);
  const [transliterationControl, setTransliterationControl] = useState(null);
  const [languages, setLanguages] = useState([]);
  const [isLongMessageWarning, setIsLongMessageWarning] = useState(false);
  const [alertShown, setAlertShown] = useState(false);
  const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false);
  const [templateSearch, setTemplateSearch] = useState("");
  const [isFlash, setIsFlash] = useState(false);
  const [enableSchedule, setEnableSchedule] = useState(false);
  const [smsCount, setSmsCount] = useState(1);
  const [charCount, setCharCount] = useState(0);
  const [postVia, setPostVia] = useState("");
  const [batch_size, setbatch_size] = useState("");
  const [time_interval, settime_interval] = useState("");
  const [isCountryModalOpen, setIsCountryModalOpen] = useState(false);
  const [isCountrySelected, setIsCountrySelected] = useState(true);
  const [showSpamWarning, setShowSpamWarning] = useState(false);
  const [spamKeywords, setSpamKeywords] = useState([]);
  const [selectedDbFile, setSelectedDbFile] = useState(null);
  const [isFileModalOpen, setIsFileModalOpen] = useState(false);
  const [previewResult, setPreviewResult] = useState(null);
  const fileInputRef = useRef(null);

  const { data: dbFiles, isLoading: dbFilesLoading } = useGetSearchFilesQuery();
  const { data: dataEnableRes } = useDataEnableServiceQuery();
  const [previewData, { data }] = usePreviewDataMutation();

  const [dateTime, setDateTime] = useState(dayjs(new Date()).format("YYYY-MM-DDTHH:mm"));
  const [sendTime, setSendTime] = useState(dayjs(new Date()).format("YYYY-MM-DD HH:mm"));
  const [minDateTime, setMinDateTime] = useState(dayjs().format("YYYY-MM-DDTHH:mm"));
  const [selectedCountry, setSelectedCountry] = useState({ id: 1, name: "India", code: "+91" });
  const [mpinModalOpen, setMpinModalOpen] = useState(false);
  const [mpin, setMpin] = useState("");
  const [mpinError, setMpinError] = useState("");
  const [isSubmittingAfterMpin, setIsSubmittingAfterMpin] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { data: headersData, isLoading: headersLoading, isError: headersError } =
    useFetchHeadersByPrincipalIdQuery(prId, { skip: !prId });
  const { data: principalEntitiesData, isLoading, isError } = useFetchPrincipalEntitiesdataQuery();
  const { data: checkmpin } = useCheckMpinStatusQuery();
  const [verifyMpin, { isLoading: isVerifyingMpin }] = useVerifyMpinStatusMutation();
  const { data: countriesData, isLoading: countriesLoading, isError: countriesError } = useGetCustomerCountriesQuery();
  const [checkSpamKeywords, { isFetching: isCheckingSpam }] = useLazyCheckSpamKeywordsQuery();
  const [uploadSplit, { isLoading: bulkIsLoading }] = useUploadSplitSMSMutation();

  const { data: templatesData, isLoading: templatesLoading, isError: templatesError, refetch: refetchTemplates } =
    useGetTemplateByPrincipalIdQuery(prId, { skip: !prId, refetchOnMountOrArgChange: true });

  // ─── Effects ───────────────────────────────────────────────────────────────
  useEffect(() => { if (principalEntitiesData) setPrincipalEntities(principalEntitiesData.data || []); }, [principalEntitiesData]);

  useEffect(() => {
    const list = headersData?.data || [];
    setHeaders(list);
  }, [headersData]);

  useEffect(() => { setTemplates(templatesData?.data || []); }, [templatesData, prId]);
  useEffect(() => { if (prId) refetchTemplates(); }, [prId, refetchTemplates]);

  const filteredTemplates = templates.filter((template) =>
    (template.template_name || "")
      .toLowerCase()
      .includes(templateSearch.trim().toLowerCase()),
  );

  useEffect(() => {
    if (!onPreviewChange) return;
    onPreviewChange({
      // ── NEW: name + trimmed pe_id ──
      entity: entityId?.pe_name
        ? `${entityId.pe_name} (${entityId.pe_id ? trimPeId(entityId.pe_id) : ""})`
        : "",
      senderId: headerName || "",
      templateName: selectedTemplateName || "",
      templateId: templateId || "",
      file: file ? file.name : "",
      dbFile: selectedDbFile ? selectedDbFile.filter_name : "",
      additionalNumbers: phoneNumbers ? `${phoneNumbers.split("\n").filter(Boolean).length} numbers` : "",
      message: smstext || "",
      smsType: smsType || "",
      schedule: enableSchedule ? sendTime : "Immediately",
      allowLong: !!isAllow,
      isFlash: !!isFlash,
      charCount: charCountState || 0,
      smsCount: smsCountState || 0,
    });
  }, [entityId, headerName, selectedTemplateName, templateId, file, selectedDbFile,
    phoneNumbers, smstext, smsType, enableSchedule, sendTime, isAllow, isFlash, charCountState, smsCountState, onPreviewChange]);

  // ─── Helpers ───────────────────────────────────────────────────────────────
  const checkForUnicodeCharacters = (text) => smsType !== "english" ? false : getUnicodeCharacters(text).length > 0;

  function getUnicodeCharacters(sentence) {
    const seen = new Set(); const unique = [];
    for (const char of sentence) {
      const cp = char.codePointAt(0);
      if (cp > 127 && !seen.has(char)) { seen.add(char); unique.push({ codePoint: cp, char, code: "U+" + cp.toString(16).toUpperCase().padStart(4, "0") }); }
    }
    return unique;
  }

  const uniqueCountries = useMemo(() => {
    const map = new Map();
    (countriesData?.data || []).forEach((item) => {
      const id = Number(item.country_id);
      if (!map.has(id)) map.set(id, { id, name: item?.country?.country_name || "", code: (item?.country?.countrycode || "").trim() });
    });
    return Array.from(map.values());
  }, [countriesData]);

  // ─── Handlers ──────────────────────────────────────────────────────────────
  const handlepreviewSubmit = async () => {
    const formData = new FormData();

    const customerId = localStorage.getItem('customer_id') || '';

    formData.append("noofdays", String(filterDatatill_days || 0));
    formData.append("customer_id", customerId);
    formData.append("smsCount", smsCountState || 0);
    formData.append("country_id", selectedCountry.id || '');
    formData.append("country_code", selectedCountry.code || '+91');
    formData.append("service_id", service_id || '');

    if (phoneNumbers && phoneNumbers.trim()) {
      const numbersArray = phoneNumbers
        .split('\n')
        .map(num => num.trim())
        .filter(num => num);
      formData.append("phoneNumbers", JSON.stringify(numbersArray));
    }

    if (file) {
      formData.append("file", file);
    } else if (selectedDbFile) {
      const cleanPath = (selectedDbFile.file_path || selectedDbFile.path)
        .replace(/\\/g, "/");
      formData.append("filePath", cleanPath);
      formData.append("customer_requestid", selectedDbFile.customer_requestid || "");
    }

    try {
      const result = await previewData(formData).unwrap();
      if (result?.file?.FirstApiPath) {
        setPreviewResult(result);
      }
    } catch (error) {
      console.error("Error uploading:", error);
      toast.error(error?.data?.error || "Preview failed");
    }
  };

  const handleSmsTypeChange = (e) => {
    const v = e.target.value; setSmsType(v); setSmsText(""); setCharCountState(0);
    setSmsCountState(0); setTemplateId(""); setPeId(""); setIsAllow(false); setCountdownTimer(null);
  };

  const MAX_ALLOWED_NUMBERS = 1000000;
  const handleFileChange = (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) { setFile(null); setSelectedDbFile(null); setFileNames(""); return; }
    const sel = files[0]; setSelectedDbFile(null);
    if (!sel) return;
    const ext = sel.name.split(".").pop().toLowerCase();
    if (!["txt", "csv"].includes(ext)) { setError("Only .txt or .csv files are allowed."); setFile(null); setFileNames(""); event.target.value = ""; return; }
    const reader = new FileReader();
    reader.onload = (e) => {
      let content = e.target.result;
      const nums = content.split(/[\n,\s]+/).map(n => n.trim()).filter(n => /^\d{10,}$/.test(n));
      if (nums.length > MAX_ALLOWED_NUMBERS) { setError("File contains more than 10 lakh numbers."); setFile(null); setFileNames(""); event.target.value = ""; return; }
      setFile(sel); setFileNames(sel.name); setError("");
    };
    reader.readAsText(sel);
  };

  const handleDbFileSelect = (f) => {
    setFile(null); if (fileInputRef.current) fileInputRef.current.value = "";
    setSelectedDbFile(f); setFileNames(`From DB: ${f.filter_name}`);
    setPostVia("SplitData");
    setIsFileModalOpen(false);
  };

  const handleEntityChange = (e) => {
    const selectedPrId = Number(e.target.value);
    const selectedEntity = principalEntities.find(ent => Number(ent.principalentity_id) === selectedPrId);
    setEntityId(selectedEntity); setPrId(selectedPrId); setIsPrincipalEntitySelected(true);
    setHeaderName(""); setTemplates([]); setSmsText(""); setTemplateId(""); setCharCountState(0); setSmsCountState(0);
    setSelectedTemplateName("");
  };

  const handleCountryModalToggle = () => setIsCountryModalOpen(p => !p);
  const handleCountrySelect = (id, name, code) => {
    const c = code.trim(); setSelectedCountry({ id, name, code: c }); setIsCountrySelected(true);
    const el = document.getElementById("mobile");
    if (el?.value?.startsWith(c)) el.value = el.value.replace(c, "").trim();
    setIsCountryModalOpen(false);
  };

  const transliterateStateChangeHandler = (e) => setIsTransliterationEnabled(e.transliterationEnabled);
  useEffect(() => {
    const loadAPI = () => google.load("elements", "1", { packages: "transliteration", callback: onLoad });
    const s = document.createElement("script"); s.src = "https://www.google.com/jsapi"; s.onload = loadAPI; document.body.appendChild(s);
  }, []);
  const onLoad = () => {
    const el = document.getElementById("txtMessage");
    if (!el) { setTimeout(onLoad, 100); return; }
    const opts = { sourceLanguage: "en", destinationLanguage: ["hi", "ar", "bn", "fa", "gu", "kn", "ml", "mr", "ne", "pa", "ta", "te", "ur"], transliterationEnabled: false, shortcutKey: "ctrl+g" };
    const ctrl = new google.elements.transliteration.TransliterationControl(opts);
    setTransliterationControl(ctrl); ctrl.makeTransliteratable(["txtMessage"]);
    setIsTransliterationEnabled(ctrl.isTransliterationEnabled());
    setLanguages(google.elements.transliteration.getDestinationLanguages(google.elements.transliteration.LanguageCode.ENGLISH));
    ctrl.addEventListener(google.elements.transliteration.TransliterationControl.EventType.STATE_CHANGED, transliterateStateChangeHandler);
  };
  const checkboxClickHandler = () => {
    if (!transliterationControl) return;
    transliterationControl.toggleTransliteration();
    const en = transliterationControl.isTransliterationEnabled(); setIsTransliterationEnabled(en);
    if (en) { setCurrentLanguage("hi"); transliterationControl.setLanguagePair(google.elements.transliteration.LanguageCode.ENGLISH, "hi"); }
  };
  const languageChangeHandler = (e) => {
    setCurrentLanguage(e.target.value);
    if (transliterationControl) transliterationControl.setLanguagePair(google.elements.transliteration.LanguageCode.ENGLISH, e.target.value);
  };

  const handleSmsTextChange = (e) => {
    const text = e.target.value; setSmsText(text);
    const trimmed = text.trimEnd();
    if (smsType === "english" && checkForUnicodeCharacters(trimmed)) {
      const chars = getUnicodeCharacters(trimmed).map(u => u.char).join(", ");
      alert(`Unicode characters (${chars}) not allowed in English SMS.`);
    }
    const special = ["^", "|", "{", "}", "[", "]", "\\", "~"];
    let cc = 0; for (const c of trimmed) cc += special.includes(c) ? 2 : 1;
    setCharCountState(cc);
    let sc = 1;
    if (smsType === "english") { if (cc <= 160) sc = 1; else if (cc <= 306) sc = 2; else sc = Math.ceil(cc / 153); }
    else { if (cc <= 70) sc = 1; else if (cc <= 134) sc = 2; else sc = Math.ceil(cc / 67); }
    setSmsCountState(sc);
    if (typeof onPreviewChange === "function") onPreviewChange(p => ({ ...p, message: trimmed, charCount: cc, smsCount: sc }));
    const lim = smsType === "english" ? 160 : 70;
    if (cc > lim && !isAllow) { setIsAllow(true); setIsLongMessageWarning(true); if (!alertShown) { alert(`Message exceeds ${lim} chars — "Allow Long Message" enabled.`); setAlertShown(true); } }
    else if (cc <= lim && isAllow) { setIsAllow(false); setIsLongMessageWarning(false); }
    else setIsLongMessageWarning(false);
  };

  const handleTemplateSelect = (text, tid, name, headerId) => {
    setSmsText(text);
    setTemplateId(tid);
    setSelectedTemplateName(name || "");

    if (headerId) {
      const header = headers.find(h => h.header_id === headerId);
      if (header) {
        setHeaderName(header.header_name);
      } else {
        setHeaderName("");
      }
    } else {
      setHeaderName("");
    }

    setIsTemplateModalOpen(false);
    handleSmsTextChange({ target: { value: text } });
  };

  const handleReviewClick = async () => {
    if (!isPrincipalEntitySelected) { toast.error("Please select a PRINCIPAL ENTITY."); return; }
    if (!headerName) { toast.error("Please select a template to get header name"); return; }
    if (smsType === "english" && checkForUnicodeCharacters(smstext)) { toast.warn("Unicode not allowed in English SMS."); return; }
    if (!file && !selectedDbFile) { toast.error("Please upload a file or select from database"); return; }
    if (!batch_size || !time_interval) { toast.error("Please enter both batch size and time interval"); return; }
    try {
      const spamCheck = await checkSpamKeywords(smstext).unwrap();
      if (spamCheck?.status === false && spamCheck?.data?.length > 0) { setSpamKeywords(spamCheck.data); setShowSpamWarning(true); toast.warn(`Spam keywords: ${spamCheck.data.join(", ")}`); return; }
      setReviewData({
        // ── NEW: name + trimmed pe_id ──
        entity: entityId?.pe_name
          ? `${entityId.pe_name} (${entityId.pe_id ? trimPeId(entityId.pe_id) : ""})`
          : "Not selected",
        senderId: headerName || "Not selected",
        smsType, smstext, templateId: templateId ? maskNumber(templateId) : "None",
        country: `${selectedCountry.name} (${selectedCountry.code})`,
        allowLongMessage: isAllow ? "Yes" : "No", isFlash: isFlash ? "Yes" : "No",
        schedule: enableSchedule ? sendTime : "Immediately",
        file: selectedDbFile ? `From DB: ${selectedDbFile.filter_name}` : file ? file.name : "No file",
        phoneNumbers: document.getElementById("mobile")?.value.trim() || "No additional numbers",
        batchSize: batch_size, timeInterval: time_interval,
        charCount: charCountState, smsCount: smsCountState, spamKeywords: spamCheck?.data || [],
      });
      setIsReviewModalOpen(true);
    } catch (e) { console.error(e); toast.error("Failed to check spam keywords."); }
  };

  const handleSubmit = async () => {
    setIsReviewModalOpen(false); setIsSubmit(true);
    if (!isPrincipalEntitySelected) { toast.error("Please select a PRINCIPAL ENTITY."); setIsSubmit(false); return; }
    if (!headerName) { toast.error("Please select a template to get header name"); setIsSubmit(false); return; }
    if (enableSchedule && dayjs(sendTime).isBefore(dayjs())) { toast.error("Schedule time cannot be in the past"); setIsSubmit(false); return; }
    const formData = new FormData();
    formData.append("smstext", (smstext || "").trimEnd());
    formData.append("template_id", templateId || "0");
    formData.append("header_name", headerName || "");
    formData.append("pe_id", entityId.pe_id);
    formData.append("country_id", selectedCountry.id || "");
    formData.append("country_code", selectedCountry.code);
    formData.append("post_via", "Split");

    const fileSource = selectedDbFile ? "chooseDb" : "uploadFile";
    formData.append("file_source", fileSource);
    formData.append("is_flash", isFlash);
    formData.append("language", smsType);
    formData.append("allowLongSms", isAllow);
    formData.append("smsCount", Number(smsCountState));
    formData.append("charCount", charCountState);
    formData.append("service_id", service_id);
    formData.append("customer_id", "");
    formData.append("time_interval", time_interval || "");
    formData.append("batch_size", batch_size || "");
    formData.append("FirstApiPath", data?.file?.FirstApiPath);
    formData.append("total_numbers", data?.results?.total_remains);
    if (enableFilterTill && filterDatatill_days) formData.append("filterdatatill_days", String(filterDatatill_days));
    if (enableSchedule) formData.append("time_to_send", sendTime);

    if (selectedDbFile) {
      formData.append("upload_file_path", selectedDbFile.path);
      formData.append("customer_requestid", selectedDbFile.customer_requestid || "");
    }
    else if (file) formData.append("upload_file", file);
    else { toast.error("Please select a file"); setIsSubmit(false); return; }

    const mob = document.getElementById("mobile")?.value.trim();
    if (mob) { const nums = mob.split("\n").map(n => n.replace(selectedCountry.code, "").trim()).filter(Boolean); formData.append("phone_number", nums.join(",")); }
    try {
      const res = await uploadSplit(formData).unwrap();
      if (res?.status) { toast.success(res?.message); resetForm(); setIsReviewModalOpen(false); setMpin(""); }
      else { let msg = res?.message || "Submission failed"; if (res?.data?.length > 0) msg += `\nSpam: ${res.data.join(", ")}`; toast.warn(msg); }
    } catch (err) {
      setMpin("");
      if (err?.data) { let msg = err.data.message || "Submission failed"; if (err.data.data?.length > 0) msg += `\nSpam: ${err.data.data.join(", ")}`; toast.warn(msg); }
      else toast.error("An error occurred while uploading.");
    } finally { setIsSubmit(false); }
  };

  const resetForm = () => {
    setPhoneNumbers(""); setFile(null); setFileNames(""); setSelectedDbFile(null);
    setEntityId(null); setHeaderName(""); setTemplates([]); setPrId(null);
    setEnableSchedule(false); setTemplateId(""); setSmsText(""); setSmsCountState(0); setCharCountState(0);
    setSmsCount(1); setCharCount(0); setPeId(""); setPostVia(""); setIsFlash(false); setIsAllow(false);
    setSendTime(formatedCurrentDateTime()); setMpin(""); setSelectedTemplateName("");
    settime_interval(""); setbatch_size("");
  };

  const handleConfrimSubmit = async () => {
    if (isSubmitting) return; setIsSubmitting(true);
    try { if (checkmpin?.data?.allow_mpin) setMpinModalOpen(true); else await handleSubmit(); }
    finally { setIsSubmitting(false); }
  };

  const verifyMpinHandler = async () => {
    try {
      const res = await verifyMpin({ mpin_pass: mpin });
      if (res?.data?.status) { setMpinModalOpen(false); setIsReviewModalOpen(false); setTimeout(async () => { await handleSubmit(); setMpin(""); }, 1000); }
      else { setMpinError(res.data.message || "Verification failed"); setMpin(""); }
    } catch (err) {
      setMpin(""); if (err.status === 404) toast.error("MPIN endpoint not found");
      else setMpinError(err.data?.message || "Invalid MPIN");
    }
  };

  if (bulkIsLoading) return <Loader />;

  return (
    <>
      {/* ── SMS Language ─────────────────────────────────────────────────── */}
      <Box sx={{ mt: 1 }}>
        <FormControl size="small" sx={{ minWidth: 100 }}>
          <InputLabel id="smsType-label" sx={{ fontSize: "0.8rem" }}>SMS Language</InputLabel>
          <Select
            labelId="smsType-label" value={smsType} label="SMS Language" onChange={handleSmsTypeChange}
            MenuProps={compactMenuProps}
            sx={{ ...glassField, "& .MuiSelect-select": { fontSize: "0.8rem" } }}
          >
            <MenuItem value="english" sx={{ fontSize: "0.8rem" }}>English Lang</MenuItem>
            <MenuItem value="other" sx={{ fontSize: "0.8rem" }}>Other Lang</MenuItem>
          </Select>
        </FormControl>
      </Box>

      {/* ── Top row: Entity + ChooseDB/UploadFile stacked on left, Mobile on right ── */}
      <Box
        sx={{
          display: "flex",
          mt: 1.5,
          gap: 2,
          alignItems: "flex-start",
          maxWidth: FORM_MAX_WIDTH,
        }}
      >
        {/* Left column */}
        <Stack spacing={1} sx={{ flexShrink: 0, alignItems: "flex-start" }}>
          {/* Entity Id — name + trimmed pe_id, with renderValue so pe_id stays visible */}
          <FormControl sx={{ width: 220 }}>
            <InputLabel id="entityId-label" sx={{ fontSize: "0.8rem" }}>Entity Id</InputLabel>
            <Select
              labelId="entityId-label"
              id="entityId-select"
              label="Entity Id"
              value={prId || ""}
              onChange={handleEntityChange}
              size="medium"
              MenuProps={compactMenuProps}
              sx={glassField}
              /* pe_name truncates with ellipsis, but pe_id stays visible to its last digit */
              renderValue={() => {
                if (!entityId?.pe_id) return "Select Entity Id";
                return (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      minWidth: 0,
                      fontSize: "0.8rem",
                    }}
                  >
                    <Box
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        minWidth: 0,
                      }}
                    >
                      {entityId.pe_name}
                    </Box>
                    <Box sx={{ flexShrink: 0, whiteSpace: "nowrap" }}>
                      ({trimPeId(entityId.pe_id)})
                    </Box>
                  </Box>
                );
              }}
            >
              <MenuItem value="" sx={{ fontSize: "0.8rem" }}>Select Entity Id</MenuItem>
              {isLoading ? (
                <MenuItem disabled sx={{ fontSize: "0.8rem" }}>Loading...</MenuItem>
              ) : isError ? (
                <MenuItem disabled sx={{ fontSize: "0.8rem" }}>No Entities Available</MenuItem>
              ) : principalEntities.length > 0 ? (
                principalEntities.map((entity, index) => (
                  <MenuItem
                    key={index}
                    value={entity.principalentity_id}
                    sx={{ fontSize: "0.8rem" }}
                  >
                    {/* ── NEW: name + trimmed pe_id ── */}
                    {entity.pe_name} ({trimPeId(entity.pe_id)})
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled sx={{ fontSize: "0.8rem" }}>No Entities Available</MenuItem>
              )}
            </Select>
          </FormControl>

          {/* ChooseDB + UploadFile side by side */}
          <Stack direction="row" spacing={1} sx={{ width: 220, alignItems: "center" }}>
            {dataEnableRes?.isdataenable !== null && (
              <Button
                variant="outlined"
                startIcon={<StorageIcon />}
                onClick={() => setIsFileModalOpen(true)}
                sx={{
                  flex: 1,
                  minWidth: 0,
                  height: FIELD_HEIGHT,
                  px: 1,
                  textTransform: "none",
                  fontSize: "0.75rem",
                  whiteSpace: "nowrap",
                  background: "rgba(255,255,255,0.7)",
                  backdropFilter: "blur(8px)",
                  borderRadius: "8px",
                  "& .MuiButton-startIcon": { mr: 0.5 },
                  "&:hover": {
                    background: "rgba(255,255,255,0.9)",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                  },
                }}
              >
                <Tooltip title={selectedDbFile ? selectedDbFile.filter_name : ""} arrow>
                  <Box
                    component="span"
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      display: "block",
                    }}
                  >
                    {selectedDbFile ? selectedDbFile.filter_name : "ChooseDB"}
                  </Box>
                </Tooltip>
              </Button>
            )}

            <Button
              component="label"
              variant="outlined"
              startIcon={<CloudUploadIcon />}
              sx={{
                flex: 1,
                minWidth: 0,
                height: FIELD_HEIGHT,
                px: 1,
                textTransform: "none",
                fontSize: "0.75rem",
                whiteSpace: "nowrap",
                background: "rgba(255,255,255,0.7)",
                backdropFilter: "blur(8px)",
                borderRadius: "8px",
                "& .MuiButton-startIcon": { mr: 0.5 },
                "&:hover": {
                  background: "rgba(255,255,255,0.9)",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                },
              }}
            >
              <Tooltip title={file ? file.name : ""} arrow>
                <Box
                  component="span"
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "block",
                  }}
                >
                  {file
                    ? file.name.length > 12
                      ? file.name.substring(0, 12) + "..."
                      : file.name
                    : "UploadFile"}
                </Box>
              </Tooltip>
              <VisuallyHiddenInput
                type="file"
                id="fileUpload"
                accept=".txt,.csv"
                onChange={handleFileChange}
                ref={fileInputRef}
              />
            </Button>
          </Stack>

          {/* Filter From LC */}
          {checkmpin?.data?.allow7_day_filter && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
              <FormControlLabel
                control={
                  <Switch
                    size="small"
                    checked={enableFilterTill}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setEnableFilterTill(checked);
                      if (!checked) setFilterDatatill_days(0);
                    }}
                  />
                }
                label="Filter From LC"
                sx={{
                  m: 0,
                  "& .MuiFormControlLabel-label": { fontSize: "0.75rem", color: "#000" },
                }}
              />
              {enableFilterTill && (
                <FormControl size="small" sx={{ width: 130 }}>
                  <InputLabel sx={{ fontSize: "0.7rem" }}>Filter Till</InputLabel>
                  <Select
                    value={filterDatatill_days}
                    label="Filter Till"
                    onChange={(e) => setFilterDatatill_days(e.target.value)}
                    MenuProps={compactMenuProps}
                    sx={{
                      fontSize: "0.75rem",
                      height: FIELD_HEIGHT,
                      minHeight: FIELD_HEIGHT,
                      maxHeight: FIELD_HEIGHT,
                      background: "rgba(255,255,255,0.7)",
                      backdropFilter: "blur(8px)",
                      borderRadius: "6px",
                    }}
                  >
                    <MenuItem value={1} sx={{ fontSize: "0.75rem" }}>Today</MenuItem>
                    <MenuItem value={2} sx={{ fontSize: "0.75rem" }}>Yesterday</MenuItem>
                    {Array.from({ length: 28 }, (_, i) => {
                      const day = i + 3;
                      return (
                        <MenuItem key={day} value={day} sx={{ fontSize: "0.75rem" }}>
                          Last {day} days
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              )}
            </Box>
          )}

          {error && (
            <Typography variant="body2" color="error" sx={{ fontSize: "0.7rem" }}>
              {error}
            </Typography>
          )}
        </Stack>

        {/* Right column: Additional Mobile Number (takes remaining space) */}
        <Stack sx={{ flex: 1, minWidth: 0 }}>
          <TextField
            id="mobile"
            multiline
            fullWidth
            rows={4}
            label="Additional Mobile Number"
            placeholder="Enter Mobile Numbers (one per line)"
            value={phoneNumbers}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9\n]/g, "");
              setPhoneNumbers(value);
            }}
            InputProps={{
              sx: { fontSize: "0.8rem", background: "rgba(255,255,255,0.7)" },
            }}
            InputLabelProps={{ sx: { fontSize: "0.8rem" } }}
          />
        </Stack>
      </Box>

      {/* ── Message Area ─────────────────────────────────────────────────── */}
      <Box>
        {smsType === "other" && (
          <Box>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isTransliterationEnabled}
                  onChange={checkboxClickHandler}
                  size="small"
                />
              }
              label="Enable Text Editor:"
              componentsProps={{ typography: { fontSize: "0.75rem" } }}
            />
            {isTransliterationEnabled && (
              <Select
                onChange={languageChangeHandler}
                disabled={!isTransliterationEnabled}
                size="small"
                value={currentLanguage}
                MenuProps={compactMenuProps}
                sx={{
                  minWidth: 30,
                  mb: 1,
                  fontSize: "0.7rem",
                  background: "rgba(255,255,255,0.7)",
                  borderRadius: "6px",
                }}
              >
                {Object.entries(languages).map(([k, v]) => <MenuItem key={v} value={v} sx={{ fontSize: "0.7rem" }}>{k}</MenuItem>)}
              </Select>
            )}
          </Box>
        )}

        <Box>
          {selectedTemplateName && (
            <Typography variant="subtitle2" sx={{ fontSize: "0.75rem", color: "#666", fontWeight: "bold" }}>
              Template Name: {selectedTemplateName}
            </Typography>
          )}
          <TextField
            label="Message"
            id="txtMessage"
            value={smstext}
            onChange={handleSmsTextChange}
            multiline
            rows={3}
            placeholder={smsType === "other" ? "70 Character Message Enter" : "160 Character Message Enter"}
            variant="outlined"
            margin="normal"
            sx={{
              width: "100%",
              maxWidth: FORM_MAX_WIDTH,
              "& .MuiOutlinedInput-root": {
                background: "rgba(255,255,255,0.7)",
                backdropFilter: "blur(8px)",
              },
            }}
            helperText={
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: 0.5 }}>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={() => setIsTemplateModalOpen(true)}
                  sx={{ textTransform: "none", fontSize: "0.7rem", px: 1, py: 0.5 }}
                >
                  Open Template
                </Button>
                <Box sx={{ fontSize: "0.7rem", color: "text.secondary" }}>
                  SMS Count: {smsCountState} | Char Count: {charCountState}
                </Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isAllow}
                      onChange={(e) => setIsAllow(e.target.checked)}
                      size="small"
                    />
                  }
                  label="Allow Long Message"
                  sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.7rem", color: "#000" } }}
                />
              </Box>
            }
            FormHelperTextProps={{ sx: { margin: 0 } }}
          />
        </Box>
      </Box>

      {/* ── Batch Size + Time Interval (Split-specific) ──────────────────── */}
      <Box sx={{ display: "flex", gap: 1.5, mt: 0.5, mb: 1 }}>
        <TextField
          label="After Every (N) Minutes"
          type="number"
          placeholder="Enter Interval"
          value={time_interval}
          onChange={(e) => settime_interval(e.target.value)}
          error={!!time_interval && time_interval < 10}
          helperText={time_interval && time_interval < 10 ? "Minimum 10 minutes required" : ""}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          inputProps={{ min: 10 }}
          sx={{ width: 220, "& .MuiInputBase-root": { ...glassField }, "& .MuiInputLabel-root": { fontSize: "0.8rem" } }}
        />
        <TextField
          label="No Of SMS In Each Batch"
          type="number"
          placeholder="Batch Size"
          value={batch_size}
          onChange={(e) => setbatch_size(e.target.value)}
          error={!!batch_size && batch_size < 1000}
          helperText={batch_size && batch_size < 1000 ? "Minimum batch size is 1000" : ""}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          inputProps={{ min: 1000 }}
          sx={{ width: 220, "& .MuiInputBase-root": { ...glassField }, "& .MuiInputLabel-root": { fontSize: "0.8rem" } }}
        />
      </Box>

      {/* ── Flash & Schedule ─────────────────────────────────────────────── */}
      <Box display="flex" alignItems="center" gap={2} mt={1}>
        <FormControlLabel
          control={<Checkbox checked={isFlash} onChange={(e) => setIsFlash(e.target.checked)} size="small" />}
          label="Is Flash"
          sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.8rem", color: "#000" } }}
        />
        <Box display="flex" alignItems="center" gap={1}>
          <FormControlLabel
            control={<Checkbox checked={enableSchedule} size="small"
              onChange={(e) => {
                const v = e.target.checked; setEnableSchedule(v);
                if (!v) { const n = dayjs().format("YYYY-MM-DD HH:mm"); setDateTime(n); setSendTime(n); }
                else setMinDateTime(dayjs().format("YYYY-MM-DDTHH:mm"));
              }} />}
            label="Schedule For Later?"
            sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.8rem", color: "#000" } }}
          />
          {enableSchedule && (
            <TextField label="Schedule Date" type="datetime-local" value={sendTime}
              onChange={(e) => {
                const v = e.target.value; const now = dayjs().format("YYYY-MM-DDTHH:mm");
                if (dayjs(v).isBefore(now)) { toast.error("Schedule time cannot be in the past"); setSendTime(now); }
                else setSendTime(v);
              }}
              size="small" InputLabelProps={{ shrink: true }} inputProps={{ min: minDateTime }}
              sx={{ width: 200, "& .MuiInputBase-root": { fontSize: "0.8rem", background: "rgba(255,255,255,0.7)" }, "& .MuiInputLabel-root": { fontSize: "0.8rem" } }}
            />
          )}
        </Box>
      </Box>

      {/* ── Country & Preview ────────────────────────────────────────────── */}
      <Box display="flex" alignItems="center" gap={2} mt={2}>
        <div className="flex items-center text-[0.8rem]">
          <label className="block font-medium text-[0.8rem]">Select Country</label>
          <div className="py-2 ms-3">
            {selectedCountry
              ? <span className="text-blue-500 cursor-pointer underline" onClick={handleCountryModalToggle}>{selectedCountry.name} ({selectedCountry.code})</span>
              : <button onClick={handleCountryModalToggle} className="text-blue-500 underline">Select Country</button>}
          </div>
          {isCountryModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
              <div className="bg-white p-6 rounded-lg max-w-sm w-full relative">
                <h2 className="text-xl font-semibold mb-4 text-[0.8rem]">Select Country</h2>
                <button onClick={() => setIsCountryModalOpen(false)} className="absolute top-2 right-2 text-gray-500 hover:text-gray-800">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
                {countriesLoading ? <p>Loading countries...</p>
                  : countriesError ? <p>No countries available</p>
                    : <div className="max-h-96 overflow-y-auto">
                      {uniqueCountries.map(c => (
                        <div key={c.id} onClick={() => handleCountrySelect(c.id, c.name, c.code)}
                          className={`p-3 mb-2 cursor-pointer rounded hover:bg-gray-100 ${selectedCountry?.id === c.id ? "bg-blue-100" : ""}`}>
                          {c.name} ({c.code})
                        </div>
                      ))}
                    </div>}
              </div>
            </div>
          )}
        </div>

        <Button variant="outlined" color="primary" size="medium"
          onClick={async () => {
            const bs = Number(batch_size), ti = Number(time_interval);
            if (!bs || bs < 1000) { toast.error("Minimum batch size is 1000"); return; }
            if (!ti || ti < 10) { toast.error("Minimum 10 minutes required"); return; }
            await handlepreviewSubmit(); await handleReviewClick();
          }}
          sx={{ textTransform: "none", fontSize: "0.8rem", px: 2 }}>
          Preview
        </Button>
      </Box>

      {/* ── Preview / Review Modal ───────────────────────────────────────── */}
      {isReviewModalOpen && (
        <Dialog open={isReviewModalOpen} onClose={() => setIsReviewModalOpen(false)} fullWidth maxWidth="md">
          <DialogTitle>Review Your SMS Details</DialogTitle>
          <DialogContent dividers>
            {!data || !reviewData ? (
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 200 }}><CircularProgress /></Box>
            ) : (
              <>
                {data?.results && (
                  <Box mb={2}>
                    <Typography variant="h6" gutterBottom>Processing Results</Typography>
                    <Grid container spacing={1}>
                      {[
                        { label: "Total Posted", value: data.results.total_posted },
                        { label: "Total Remains", value: data.results.total_remains },
                        { label: "Last Campaign Filter", value: data.results.last_day_campaign },
                        { label: "Global Blacklist", value: data.results.total_global_blacklist },
                        { label: "Customer Blacklist", value: data.results.total_customer_blacklist },
                        { label: "Duplicates", value: data.results.total_duplicates },
                        { label: "Estimated Cost", value: data.results.total_cost },
                      ].map(({ label, value }) => (
                        <Grid key={label} item xs={6} md={2}>
                          <Paper variant="outlined" sx={{ p: 0.75, borderRadius: 1.5, textAlign: "center" }}>
                            <Typography variant="caption" color="text.secondary" display="block">{label}</Typography>
                            <Typography variant="body2" fontWeight="bold">{value ?? "-"}</Typography>
                          </Paper>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                )}
                {reviewData?.spamKeywords?.length > 0 && (
                  <Box sx={{ backgroundColor: "#fff3cd", color: "#856404", p: 2, borderRadius: 1, mb: 2 }}>
                    <Typography variant="subtitle1" fontWeight="bold">Warning: Spam Keywords Detected</Typography>
                    <Typography variant="body2">Keywords: {reviewData.spamKeywords.join(", ")}</Typography>
                  </Box>
                )}
                <Box>
                  <Typography variant="h6" gutterBottom>SMS Details</Typography>
                  <Grid container spacing={2}>
                    {[
                      { label: "Entity", value: reviewData?.entity },
                      { label: "Header Name", value: reviewData?.senderId },
                      { label: "SMS Type", value: reviewData?.smsType === "english" ? "English" : "Other Languages" },
                      { label: "Message", value: <Box sx={{ whiteSpace: "pre-wrap" }}>{reviewData?.smstext}</Box> },
                      { label: "No of Days", value: filterDatatill_days || "0" },
                      { label: "Allow Long Message", value: reviewData?.allowLongMessage || (isAllow ? "Yes" : "No") },
                      { label: "Is Flash", value: reviewData?.isFlash || (isFlash ? "Yes" : "No") },
                      { label: "Batch Size", value: reviewData?.batchSize },
                      { label: "Time Interval (min)", value: reviewData?.timeInterval },
                      { label: "Additional Numbers", value: reviewData?.phoneNumbers || "None" },
                      { label: "Message Stats", value: `${reviewData?.charCount} characters | ${reviewData?.smsCount} SMS` },
                    ].map(({ label, value }) => (
                      <Grid key={label} item xs={12} md={4}>
                        <Paper variant="outlined" sx={{ p: 1, borderRadius: 2 }}>
                          <Typography variant="body2" color="text.secondary">{label}</Typography>
                          <Typography variant="subtitle2" fontWeight="bold">{value ?? "-"}</Typography>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </>
            )}
          </DialogContent>
          <strong style={{ color: data?.results?.is_campaign_ready === "yes" ? "green" : "red", textAlign: "center" }}>
            {data?.results?.message}
          </strong>
          <DialogActions>
            <Button onClick={() => setIsReviewModalOpen(false)}>Edit</Button>
            <Button variant="contained" color="primary" onClick={handleConfrimSubmit}
              disabled={!data?.results?.total_remains || !reviewData || data.results.is_campaign_ready !== "yes"}>
              {isSubmitting ? "Submitting..." : "Confirm & Submit"}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* ── MPIN Modal ───────────────────────────────────────────────────── */}
      <Dialog open={mpinModalOpen} onClose={() => setMpinModalOpen(false)}>
        <DialogTitle>Enter MPIN</DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>MPIN verification is required to proceed</Typography>
          <TextField autoFocus margin="dense" label="Enter MPIN" type="password" fullWidth variant="outlined"
            value={mpin} onChange={(e) => { setMpin(e.target.value); setMpinError(""); }}
            error={!!mpinError} helperText={mpinError} autoComplete="off" />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setMpinModalOpen(false); setMpin(""); setIsSubmittingAfterMpin(false); }}>Cancel</Button>
          <Button onClick={verifyMpinHandler} color="primary" disabled={isVerifyingMpin}>
            {isVerifyingMpin ? <CircularProgress size={24} /> : "Verify"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Template Modal ───────────────────────────────────────────────── */}
      {isTemplateModalOpen && (
        <Dialog
          open={isTemplateModalOpen}
          onClose={() => { setIsTemplateModalOpen(false); setTemplateSearch(""); }}
        >
          <DialogTitle sx={{ fontSize: "0.75rem", fontWeight: "bold", pb: 0.5 }}>Select Template</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              size="small"
              label="Search template by name"
              value={templateSearch}
              onChange={(e) => setTemplateSearch(e.target.value)}
              sx={{ mb: 1.5 }}
            />
            {templatesLoading ? <CircularProgress />
              : templatesError ? <Typography color="error">Error loading templates</Typography>
                : filteredTemplates.length > 0
                  ? <List sx={{ backgroundColor: "#fff", p: 0 }}>{filteredTemplates.map(t => (
                    <ListItem button key={t.template_id}
                      sx={{ mb: 1, backgroundColor: "#fff", border: "1px solid #e0e0e0", borderRadius: 1, "&:hover": { backgroundColor: "#f5f5f5" } }}
                      onClick={() => {
                        handleTemplateSelect(
                          t.template_text,
                          t.trai_template_id,
                          t.template_name,
                          t.header_id
                        );
                      }}>
                      <ListItemText
                        primary={
                          <>
                            <span style={{ fontSize: "0.75rem", fontWeight: "bold" }}>
                              Template: {t.template_name}
                            </span>
                            <br />
                            <span style={{ fontSize: "0.75rem" }}>{t.template_text}</span>
                          </>
                        }
                        secondary={
                          <>
                            <span style={{ fontSize: "0.7rem" }}>ID: {maskNumber(t.trai_template_id)}</span>
                            {t.header_id && (
                              <>
                                <br />
                                <span style={{ fontSize: "0.7rem", color: "#1976d2" }}>
                                  Header: {headers.find(h => h.header_id === t.header_id)?.header_name || "Unknown"}
                                </span>
                              </>
                            )}
                          </>
                        }
                      />
                    </ListItem>
                  ))}</List>
                    : <Typography>{templateSearch ? "No templates match your search" : "No templates available"}</Typography>}
          </DialogContent>
                  <DialogActions><Button onClick={() => { setIsTemplateModalOpen(false); setTemplateSearch(""); }}>Close</Button></DialogActions>
        </Dialog>
      )}

      {/* ── DB File Modal ────────────────────────────────────────────────── */}
      {isFileModalOpen && (
        <Dialog open={isFileModalOpen} onClose={() => setIsFileModalOpen(false)} maxWidth={false}
          sx={{ "& .MuiDialog-paper": { width: { xs: "95vw", sm: "60vw", md: "50vw" }, maxHeight: "80vh" } }}>
          <DialogTitle sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Select File From Database</DialogTitle>
          <DialogContent>
            {dbFilesLoading ? <Box sx={{ display: "flex", justifyContent: "center" }}><CircularProgress /></Box>
              : dbFiles?.data?.length > 0
                ? <Box sx={{ width: "100%" }}>
                  <TableContainer>
                    <Table>
                      <TableHead sx={{ bgcolor: "#0288d1", "& th": { color: "white", fontSize: "0.75rem" } }}>
                        <TableRow>
                          {["Sr.No", "Filter Name", "File No", "Total Count", "Request ID", "Fields In File", "Created At", "Select"].map(h => (
                            <TableCell key={h} sx={{ textAlign: "center", borderRight: "0.5px solid #B0B0B0" }}>{h}</TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {dbFiles.data.map((f, i) => (
                          <TableRow key={f.path}>
                            {[i + 1, f.filter_name, f.page_no, f.totalcount, f.customer_requestid,
                            ["", "null", "undefined", "NA"].includes(String(f.fieldsinfile)) ? "Mobile" : f.fieldsinfile,
                            dayjs(f.createdat).format("DD/MM/YYYY")].map((val, ci) => (
                              <TableCell key={ci} sx={{ padding: "8px", textAlign: "center", borderRight: "0.5px solid #B0B0B0", fontSize: "0.75rem" }}>{val}</TableCell>
                            ))}
                            <TableCell sx={{ padding: "8px", borderRight: "0.5px solid #B0B0B0" }}>
                              <Radio size="small" checked={selectedDbFile?.path === f.path} onChange={() => handleDbFileSelect(f)} />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {selectedDbFile && (
                    <Box sx={{ mt: 2, textAlign: "right" }}>
                      <Button size="small" variant="contained"
                        onClick={() => handleDbFileSelect(selectedDbFile)}>
                        Submit
                      </Button>
                    </Box>
                  )}
                </Box>
                : <Typography>No files available in database</Typography>}
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default Split;